// Document dialog's Concerning picker: the shared <ConcerningsPanel> bound to
// the document slice's selection, so Documents get the exact same tree and
// behaviour as Unknowns (and the Factor/Move panels it was extracted from).

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import {
    addSelectedDocumentConcerning,
    removeSelectedDocumentConcerning
} from '../../slices/documentSlice';
import ConcerningsPanel from './concernings-panel';

interface DocumentConcerningsPanelProps {
    height: number;
    onHide?: () => void;
}

const DocumentConcerningsPanel: React.FC<DocumentConcerningsPanelProps> = ({ height, onHide }) => {
    const dispatch = useDispatch();
    const selectedConcernings = useSelector((state: RootState) => state.document.selectedConcernings);

    return (
        <ConcerningsPanel
            height={height}
            onHide={onHide}
            selectedConcernings={selectedConcernings}
            onToggleConcerning={(concerningId) => {
                if (selectedConcernings.includes(concerningId)) {
                    dispatch(removeSelectedDocumentConcerning(concerningId));
                } else {
                    dispatch(addSelectedDocumentConcerning(concerningId));
                }
            }}
        />
    );
};

export default DocumentConcerningsPanel;
